import { FC } from 'react';
import { Container } from './components';

interface RefusedProps {
  interview?: any;
}

const Refused: FC<RefusedProps> = ({ interview }) => {
  // Est-ce qu'Alex est l'auteur de la proposition ?
  const isAuthor = String(interview?.authorId) === String(interview?.mentorship?.menteeId);

  return (
    <Container>
      <p>
        {isAuthor 
          ? "Votre mentor a refusé votre proposition d'entretien."
          : "Vous avez refusé cette proposition d'entretien."}
      </p>
    </Container>
  );
};

export default Refused;